+function ($) {
    'use strict';
    var wi_pm = window.wi_pm;
    window.wi_pm = {
        init: function () {
            wi_pm.sections.init();
            $(window).on('resize', wi_pm.refresh);
            wi_pm.refresh();
            $(document).on('click', ".pm-confirm-delete", function (event) {
                event.preventDefault();
                event.stopPropagation();
                var project_id = $(this).attr('data-id');
                wiModal.get({
                    modal: 'delete_confirmation',
                    module: 'project_manager',
                    language_id: language_id,
                    project_id: project_id
                });
            });
            $(document).on('click', "#project_manager_delete_btn", function (event) {
                event.preventDefault();
                event.stopPropagation();
                var form_data = $("#project_manager_delete_form").serialize();
                $.ajax({
                    url: urls.project_manager + '/delete',
                    type: 'POST',
                    data: form_data,
                    success: function (jData) {
                        $('#delete_confirmation').modal('hide');
                        wiAlerts.add(jData.status, jData.title, jData.msg);
                        $('tr#project_manager_' + jData.id).remove();
                    }
                });
            });
        },
        refresh: function () {
            wi_pm.layout.init();
            localID = 'pm-' + referral_id;
            pmObject = localStorage.getItem(localID);
            if (pmObject) {
                pmObject = JSON.parse(pmObject);
                if (pmObject.collapseTab && $(pmObject.collapseTab).closest('.navbar').length) {
                    pmObject.collapseTab = '';
                    pmObject.collapseTabSection = '';
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                }
            } else {
                pmObject = {
                    mainTab: '',
                    mainSubTab: '',
                    stageTab: '',
                    collapseTab: '',
                    collapseTabSection: '',
                    targetId: '',
                    targetType: ''
                };
                localStorage.setItem(localID, JSON.stringify(pmObject));
            }
            wi_pm.layout.set.sections();
        },
        layout: {
            init: function () {
                var window_w = $(window).width();
                if ($('#nav-affix').length && window_w >= 991) {
                    var offset = $('#nav-affix').offset();
                    var top = offset.top;
                    $('#nav-affix').affix({
                        offset: {
                            top: top
                        }
                    }).on('affix.bs.affix', function () {
                        wi_pm.layout.affixSize();
                    });
                }
            },
            set: {
                sections: function () {
                    if (pmObject.mainTab && $(pmObject.mainTab).length) {
                        $(pmObject.mainTab).tab('show');
                    }
                    if (pmObject.mainSubTab && $(pmObject.mainSubTab).length) {
                        $(pmObject.mainSubTab).tab('show');
                    }
                    if (pmObject.stageTab && $(pmObject.stageTab).length) {
                        $(pmObject.stageTab).tab('show');
                    }
                    if (pmObject.collapseTab && $(pmObject.collapseTab).length) {
                        $(pmObject.collapseTab).collapse('show');
                    }
                    if (pmObject.targetId && pmObject.targetType) {
                        var targetId   = pmObject.targetId;
                        var targetType = pmObject.targetType;
                        var collapseTab = pmObject.collapseTab;
                        pmObject.targetId   = '';
                        pmObject.targetType = '';
                        localStorage.setItem(localID, JSON.stringify(pmObject));
                        wi_pm.layout.set.autoOpen(targetId, targetType, collapseTab);
                    }
                },
                autoOpen: function (targetId, targetType, collapseTab) {
                    var selector, $container;

                    if (targetType === 'tasks') {
                        selector   = '.task-view[data-task-id="' + targetId + '"]';
                        $container = $('#tasks_area');
                    } else if (targetType === 'media') {
                        selector   = '.media-view[data-file-id="' + targetId + '"]';
                        var sectionId = collapseTab ? collapseTab.replace('#sections', '') : '';
                        $container = sectionId ? $('#media-project_manager_sections-' + sectionId) : $('.media-files').first();
                    } else {
                        return;
                    }

                    if (!$container.length) return;

                    var $el = $container.find(selector);
                    if ($el.length) {
                        $el.first().trigger('click');
                        return;
                    }

                    var observer = new MutationObserver(function (mutations, obs) {
                        var $el = $container.find(selector);
                        if ($el.length) {
                            obs.disconnect();
                            $el.first().trigger('click');
                        }
                    });
                    observer.observe($container[0], { childList: true, subtree: true });
                    setTimeout(function () { observer.disconnect(); }, 10000);
                }
            },
            affixSize: function () {
                $('#nav-affix').width($('#nav-affix').parent().innerWidth() - 30);
            }
        },
        sections: {
            init: function () {
                wi_pm.sections.collapse();
                wi_pm.sections.tabs();
            },
            collapse: function () {
                $(document).on('hide.bs.collapse', '.collapse', function () {
                    if ($(this).closest('.navbar').length) return;
                    pmObject.collapseTab = '';
                    pmObject.collapseTabSection = '';
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
                $(document).on('show.bs.collapse', '.collapse', function (e) {
                    if ($(this).closest('.navbar').length) return;
                    var tab_id = $(this).data('id');
                    if (pmObject.collapseTabSection && $('#section-tabs' + tab_id).find(pmObject.collapseTabSection).length) {
                        $(pmObject.collapseTabSection).tab('show');
                    }else{
                        $('#section-tabs' + tab_id + ' a:first').tab('show');
                    }
                    $(e.target).closest('.panel').siblings().find('.panel-collapse').collapse('hide');
                    //.
                    pmObject.collapseTab = '#' + $(this).attr('id');
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
            },
            tabs: function () {
                $(document).on('click', '.tab-main', function () {
                    pmObject.mainTab = '#' + $(this).attr('id');
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
                $(document).on('click', '.tab-sub-main', function () {
                    pmObject.mainSubTab = '#' + $(this).attr('id');
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
                $(document).on('click', '.tab-stage', function () {
                    pmObject.stageTab = '#' + $(this).attr('id');
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
                $(document).on('click', '.tab-section', function () {
                    pmObject.collapseTabSection = '#' + $(this).attr('id');
                    localStorage.setItem(localID, JSON.stringify(pmObject));
                });
                $(document).on('hide.bs.tab', '.tab-stage', function () {
                    $('.collapse').collapse('hide');
                });
            }
        }
    };
    $(function () {

        wi_pm = window.wi_pm;
        wi_pm.init();

        wiLayout.loader('remove');
    });
}(jQuery);
